import Vue from 'vue'
import Router from 'vue-router'

import SpatialNavigation from 'js-spatial-navigation'

// import store from '@/store/index'
// import {requireAuth} from '@/utils/constants'
import { platform } from '@/utils/constants'

import Welcome from '@/pages/site/Welcome'
import LoginTv from '@/pages/site/LoginTv'
import LoginBrowser from '@/pages/site/LoginBrowser'
// import browserRegister from '@/pages/site/BrowserRegister'

import SubcriptionError from '@/pages/site/SubcriptionError'

import AppContent from '@/pages/site/AppContent'
import RootContentCategories from '@/pages/contents/RootContentCategories'
import ContentCategory from '@/pages/contents/ContentCategory'
import CategoryTrailer from '@/pages/contents/CategoryTrailer'
import ContentDetail from '@/pages/contents/ContentDetail'
import ContentTrailer from '@/pages/contents/ContentTrailer'
import ContentView from '@/pages/contents/ContentView'

import LiveCategories from '@/pages/contents/LiveCategories'

import RootProductCategories from '@/pages/products/RootProductCategories'
import ProductCategory from '@/pages/products/ProductCategory'
import ProductDetail from '@/pages/products/ProductDetail'
import Cart from '@/pages/cart/Cart'
import Settings from '@/pages/settings/Settings'
import Info from '@/pages/settings/Info'
import SettingsLogin from '@/pages/settings/Login'
import UnlinkUser from '@/pages/settings/UnlinkUser'
import SettingsUser from '@/pages/settings/settings-user'
import PurchaseSummary from '@/pages/site/PurchaseSummary'
import Search from '@/pages/search/Search'
import LegalWarning from '@/pages/site/LegalWarning'
import PrivacyPolicy from '@/pages/site/PrivacyPolicy'
import CookiesPolicy from '@/pages/site/CookiesPolicy'
import Compliance from '@/pages/site/Compliance'

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes: [
    // {
    //   path: '/intro',
    //   name: 'intro',
    //   component: Intro
    // },
    {
      path: '/',
      name: 'welcome',
      component: Welcome
    },
    {
      path: '/login-tv',
      name: 'login-tv',
      component: LoginTv
    },
    {
      path: '/login-browser',
      name: 'login-browser',
      component: LoginBrowser
    },
    // {
    //   path: '/browser-register',
    //   name: 'browser-register',
    //   component: browserRegister
    // },
    {
      path: '/subcription-error',
      name: 'subcription-error',
      component: SubcriptionError
    },
    {
      path: '/legal-warning',
      name: 'legal-warning',
      component: LegalWarning
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: PrivacyPolicy
    },
    {
      path: '/cookies-policy',
      name: 'cookies-policy',
      component: CookiesPolicy
    },
    {
      path: '/compliance',
      name: 'compliance',
      component: Compliance
    },
    {
      path: '/content',
      component: AppContent,
      // beforeEnter: requireAuthentication,
      children: [
        {
          path: '/',
          name: 'content',
          component: RootContentCategories,
          children: [
            {
              path: 'content-category/:id',
              name: 'content-category',
              component: ContentCategory
            },
            {
              path: 'category-trailer/:id',
              name: 'category-trailer',
              component: CategoryTrailer
            },
            {
              path: 'content-detail/:id',
              name: 'content-detail',
              component: ContentDetail
            },
            {
              path: 'content-trailer/:id',
              name: 'content-trailer',
              component: ContentTrailer
            },
            {
              path: 'content-view/:id',
              name: 'content-view',
              component: ContentView
            },
            {
              path: 'purchase-summary',
              name: 'purchase-summary-content',
              component: PurchaseSummary
            }
          ]
        }
      ]
    },
    {
      path: '/live-categories',
      component: AppContent,
      children: [
        {
          path: '/',
          name: 'live-categories',
          component: LiveCategories
        }
      ]
    },
    {
      path: '/shop',
      component: AppContent,
      children: [
        {
          path: '/',
          name: 'shop',
          component: RootProductCategories,
          children: [
            {
              path: 'category/:id',
              name: 'shop-category',
              component: ProductCategory
            },
            {
              path: 'product/:id',
              name: 'shop-product',
              component: ProductDetail
            },
            {
              path: 'purchase-summary',
              name: 'purchase-summary-product',
              component: PurchaseSummary
            }
          ]
        }
      ]
    },
    {
      path: '/cart',
      component: AppContent,
      children: [
        {
          path: '/',
          name: 'cart',
          component: Cart,
          children: [
            {
              path: 'purchase-summary',
              name: 'purchase-summary-cart',
              component: PurchaseSummary
            }
          ]
        }
      ]
    },
    {
      path: '/settings',
      component: AppContent,
      // beforeEnter: requireAuthentication,
      children: [
        {
          path: '/',
          name: 'settings',
          component: Settings,
          children: [
            {
              path: 'info/',
              name: 'info',
              component: Info
            },
            {
              path: 'unlink-user/',
              name: 'unlink-user',
              component: UnlinkUser
            },
            {
              path: 'login/',
              name: 'settings-login',
              component: SettingsLogin
            },
            {
              path: 'settings-user/',
              name: 'settings-user',
              component: SettingsUser
            }
          ]
        }
      ]
    },
    {
      path: '/search',
      component: AppContent,
      children: [
        {
          path: '/',
          name: 'search',
          component: Search,
          children: [
            {
              path: 'content-detail/:id',
              name: 'search-content-detail',
              component: ContentDetail
            },
            {
              path: 'content-view/:id',
              name: 'search-content-view',
              component: ContentView
            },
            {
              path: 'purchase-summary',
              name: 'search-purchase-summary-content',
              component: PurchaseSummary
            }
          ]
        }
      ]
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

router.beforeEach((to, from, next) => {
  // ocultamos navside
  let sidenav = document.getElementById('sidenav-app')
  if (platform === 'browser' && sidenav) { document.getElementById('sidenav-app').style.width = '0' }
  // detenemos controles navegación
  SpatialNavigation.pause()
  next()
})

// // login required
// function requireAuthentication (to, from, next) {
//   if (requireAuth && !store.getters.loggedIn) {
//     next({path: '/login'})
//   } else {
//     next()
//   }
// }

export default router



// WEBPACK FOOTER //
// ./src/router/index.js